<div class="datalistContainer w-100">
  <input class="datalistInput form-control-plaintext pl-1 w-100" placeholder=""  [(ngModel)]="query" (ngModelChange)="inputChange()">
  <div  class="datalistSortedList">
    <div class="datalistListItem" *ngFor="let item of sortedList; trackBy: trackByFn" (click)="setValue(item)" [innerHTML]=toHtml(item)>
    </div> 
  </div>
</div>
